module.exports = __webpack_public_path__ + "img/lm-4.661bec25.png";